<main class="em-l-container">
  <!--<h4>Entitlement > Client</h4>-->
  <div>
    <entitlement-breadcrumbs
      [items]="breadcrumbItems"
    ></entitlement-breadcrumbs>
    <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom">
      <div class="em-c-toolbar__item">
        <div class="em-c-dropdown-check em-js-dropdown-check">
          <h5 class="entitlement-header">Client:</h5>
          <ul class="em-c-tags entitlement-tag">
            <li class="em-c-tags__item em-js-tags-item">
              <a
                class="em-c-tags__link em-js-tags-trigger"
                [routerLink]="['/client']"
              >
                <span class="em-c-tags__text"> {{ client?.name }} </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- End em-c-dropdown-check -->
      </div>
      <!-- end em-c-toolbar__item -->
    </div>

    <div class="em-c-toolbar em-c-toolbar--order em-u-margin-bottom">
      <div class="em-c-toolbar__item">
        <div class="em-c-dropdown-check em-js-dropdown-check">
          <h5>Service list</h5>
        </div>
        <!-- End em-c-dropdown-check -->
      </div>
      <!-- end em-c-toolbar__item -->
      <div class="em-c-toolbar__item em-is-aligned-right">
        <div class="em-c-btn-group">
          <div class="em-c-field__body top-searchbox em-c-field em-is-readonly">
            <input
              class="em-c-input em-js-input"
              placeholder="Search"
              [(ngModel)]="searchString"
            />
            <svg
              class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
              (click)="clearSearch()"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
              ></use>
            </svg>
          </div>
          <!--<button class="em-c-btn em-c-btn--primary em-c-btn--medium">
            <span class="em-c-btn__text">Add</span>
          </button>-->
          <!-- end em-c-btn -->
        </div>
        <!-- end em-c-btn-group -->
      </div>
      <!-- end em-c-toolbar__item -->
    </div>

    <ul class="em-c-accordion">
      @for (service of services | serviceFilter: searchString; track service) {
        <li
          class="em-c-accordion__item em-js-accordion-item {{
            service.id !== expandServiceId ? 'em-is-closed' : ''
          }}"
          id="accordion-panel-{{ service.id }}"
        >
          <div class="em-c-accordion__header" (click)="expand(service.id)">
            <a class="em-c-accordion__title em-js-accordion-trigger">
              <div
                class="em-u-display-flex em-u-width-100"
                style="justify-content: space-between; align-items: center"
              >
                <div>
                  <svg class="em-c-icon em-c-icon--small em-c-accordion__icon">
                    <use
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xlink:href="assets/unity-1.6.0/images/em-icons.svg#caret-down"
                    ></use>
                  </svg>
                  <span class="em-c-accordion__title-text">{{
                    service.name
                  }}</span>
                </div>
                <div>
                  <button
                    unity-button
                    [routerLink]="[
                      '/entitlement-service-client',
                      clientId,
                      service.id,
                    ]"
                    size="small"
                    variant="tertiary"
                    icon="settings"
                    [iconOnly]="true"
                  ></button>
                </div>
              </div>
            </a>
          </div>
          <!-- end em-c-accordion__header -->
          @for (
            entitlementClient of entitlementClients;
            track entitlementClient
          ) {
            <div>
              @if (entitlementClient.serviceId === service.id) {
                <div class="em-c-accordion__body">
                  <div class="em-c-table-object__body-inner">
                    <table class="em-c-table">
                      <!-- Table Header -->
                      <thead class="em-c-table__header">
                        <tr class="em-c-table__header-row">
                          @for (
                            serviceKey of service.serviceKeys;
                            track serviceKey
                          ) {
                            <th scope="col" class="em-c-table__header-cell">
                              {{ serviceKey.key }}
                            </th>
                            <th scope="col" class="em-c-table__header-cell">
                              Description
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody class="em-c-table__body">
                        @for (
                          entitlement of entitlementClient.entitlements;
                          track entitlement
                        ) {
                          <tr class="em-c-table__row">
                            @for (
                              serviceKey of service.serviceKeys;
                              track serviceKey
                            ) {
                              <td class="em-c-table__cell em-js-cell">
                                <span>
                                  {{ entitlement["data"][serviceKey.key] }}
                                </span>
                              </td>
                              <td class="em-c-table__cell em-js-cell">
                                <span>
                                  {{
                                    (entitlement["description"] &&
                                      entitlement["description"][
                                        serviceKey.key
                                      ]) ||
                                      "No Description"
                                  }}
                                </span>
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <!-- end div table -->
                </div>
              }
              <!-- end em-c-accordion__body -->
            </div>
          }
        </li>
      }
      <!-- end em-c-accordion__item -->
    </ul>
    <!-- end em-c-accordion -->
  </div>
</main>
